module.exports = __webpack_public_path__ + "static/img/search_subcat_item_09_show.887efc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_09_show.jpg
// module id = 6JFg
// module chunks = 0